import { Component, TemplateRef, ViewChild, Input } from "@angular/core";
import { PortalService } from "../../services/portal-service.service";
import { UntypedFormGroup } from "@angular/forms";
import { Contracts } from "../../models/contracts";
import { ActivationDetailsComponent } from "../activation-details/activation-details.component";
import { OfflineSurrenderRequest } from "../../models/tokens";
import { LogService } from "../../services/log.service";
import { MatDialog } from "@angular/material/dialog";

@Component({
  standalone: false,
  selector: "app-offline-surrender",
  templateUrl: "./offline-surrender.component.html",
  styleUrls: ["./offline-surrender.component.scss"],
})
export class OfflineSurrenderComponent {
  @ViewChild("surrenderModal") surrenderModalRef: TemplateRef<any>;
  @ViewChild(ActivationDetailsComponent)
  ActivationDetailsComponent: ActivationDetailsComponent;

  SurrenderForm: UntypedFormGroup;
  @Input() contract: Contracts;
  showTokens = false;
  surrenderToken: string;
  applianceUuid: string;

  error: any = null;
  success = false;
  failed = false;
  surrendering = false;
  closeResult: string;
  removed: any = [];
  removeFailed: any = [];
  selections = false;

  constructor(
    private portalService: PortalService,
    private dialog: MatDialog,
    private logService: LogService,
  ) {}

  get mailtoLinkSurrender(): string {
    const subject = encodeURIComponent("Surrender Increase Request");
    const body = encodeURIComponent(`Hello Support,
  
  I require a surrender increase on contract ${this.contract.id}.`);
    return `mailto:support@example.com?subject=${subject}&body=${body}`;
  }

  async offlineReturn() {
    this.resetMessage();
    if (this.surrendering) return;
    this.surrendering = true;
    const r = new OfflineSurrenderRequest();
    r.product = this.contract.product;
    r.token = this.surrenderToken;
    r.uuid = this.applianceUuid;
    try {
      await this.portalService.offlineSurrender(r, this.contract.id);
      this.success = true;
    } catch (error) {
      this.success = false;
      this.error = error;
      this.open(this.surrenderModalRef);
    } finally {
      this.surrendering = false;
    }
  }

  resetMessage() {
    this.failed = false;
    this.error = null;
    this.success = false;
  }

  open(content) {
    this.dialog
      .open(content, { width: "960px" })
      .afterClosed()
      .subscribe(() => this.reset());
  }

  closeDialog(): void {
    this.dialog.closeAll();
  }

  reset() {
    this.removed = [];
    this.removeFailed = [];
    this.failed = false;
    this.error = null;
    this.success = false;
  }

  surrenderDisabled(): boolean {
    return this.surrendering || !this.applianceUuid || !this.surrenderToken || this.contract.returnsRemaining == 0;
  }
} // end
